import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatPaginator, MatPaginatorModule } from "@angular/material/paginator";
import { Subscription } from "rxjs";
import { CustomerMapping } from "../../_model/customer-mapping-response/customer-mapping";
import { CustomerMappingResponse } from '../../_model/customer-mapping-response/customer-mapping-response';
import { ConfirmDialogComponent } from "../../components/confirm-dialog/confirm-dialog.component";
import { ClientStateService } from "../../components/navbar/client-state.service";
import { CustomerMappingService } from '../../service/customer-mapping.service';
import { SnackbarService } from "../../service/snackbar.service";
import { CreateDialog } from "./dialog/create-dialog";
import { CustomerMappingArray } from "../../_model/customer-mapping-response/customer-mapping-array";
import { FormGroup, ReactiveFormsModule} from '@angular/forms';
import { MatCardModule  } from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CustomerMappingMultipleInputFilterComponent } from '../../components/customer-mapping-multiple-input-filter/customer-mapping-multiple-input-filter.component';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
interface MappingProperty {
  displayName: string;
  value: string;
  toolTip?: string;
  property: string;
}

@Component({
  selector: 'app-customer-mapping',
  templateUrl: './customer-mapping.component.html',
  standalone: true,
  imports: [MatCardModule, MatTooltipModule, MatProgressSpinnerModule, MatPaginatorModule, CustomerMappingMultipleInputFilterComponent, MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatSelectModule, MatButtonModule, MatDialogModule],
  styleUrls: ['./customer-mapping.component.scss']
})
export class CustomerMappingComponent implements OnInit, OnDestroy {

  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
  length!: number;
  isLoadingResults = true;
  isLoadingData = false;
  customerMappingData!: CustomerMappingResponse | null;
  // customerMapping: CustomerMappingArray;
  selectedFilters: FormGroup | null = null;
  subscription!: Subscription;
  paginatorSubscription!: Subscription;
  private rentokilMappingCache = new Map<any[], MappingProperty[]>();

  constructor(private service: CustomerMappingService,
              private sbService: SnackbarService,
              private clientStateService: ClientStateService,
              private dialog: MatDialog) {
  }

  ngOnInit() {
    this.isLoadingData = true;
    this.isLoadingResults = true;
    this.selectedFilters = null;
    this.initializeCustomerMapping(0, 100);
    this.subscription = this.clientStateService.clientStateChanged$.subscribe(() =>{
      this.paginator.firstPage();
      this.paginator.pageSize = 100;
      this.selectedFilters = null;
      this.initializeCustomerMapping(0,100)
    });

    this.paginatorSubscription = this.paginator.page.subscribe((event) => {
      this.initializeCustomerMapping(event.pageIndex, event.pageSize);
    });
  }

  createDialog(): void {
    const dialogRef = this.dialog.open(CreateDialog, {
      width: '500px',
    });
    this.afterClose(dialogRef);
  }

  editDialog(customerMapping: CustomerMappingArray): void {
    const dialogRef = this.dialog.open(CreateDialog, {
      width: '500px',
      data: customerMapping
    });
    //console.log(customerMapping)
    this.afterClose(dialogRef);
  }

  delete(customerMapping: CustomerMappingArray): void {

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: 'This will delete the Customer Mapping permanently'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.isLoadingResults = true;
        this.service.deleteCustomerMapping(customerMapping.customerMappingId).subscribe(response => {
          if (response.status == 'ERROR') {
            this.sbService.openDefault(response.message);
            this.isLoadingResults = false;
          } else {
            this.sbService.openDefault('Customer Mapping deleted successfully');
            this.initializeCustomerMapping(0,100);
          }
        });
      }
    });
  }

  private afterClose(dialogRef: MatDialogRef<CreateDialog, any>) {
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.initializeCustomerMapping(0,100);
      }
    });
  }

  public initializeCustomerMapping(page: number, size: number) {
    this.isLoadingResults = true;
    this.customerMappingData = null;
    this.rentokilMappingCache.clear(); // Clear cache when reloading data
    this.service.getCustomerMapping(page,size).subscribe(response => {
      //console.log(response)
      if (response.data.tablePagination && response.data.tablePagination.last) {
        this.length = response.data.customerMappingRows.length;
      } else {
        this.length =
          this.paginator.pageSize * (this.paginator.pageIndex + 1) + 1;
      }
        this.customerMappingData = response;
        this.isLoadingResults = false;
        this.isLoadingData = true;
      },
      () => this.isLoadingResults = false);
  }

  // public getFilters(){
  //   this.isLoadingResults = true;
  //   this.service.filterCustomerMapping(this.selectedFilters).subscribe(response => {
  //     console.log(response)
  //   })
  // }

  public getFilters(page: number,size: number) {
    this.isLoadingResults = true;
    //console.log(this.selectedFilters)
    if(this.selectedFilters != null){
      this.rentokilMappingCache.clear(); // Clear cache when filtering data
      this.service.filterCustomerMapping(this.selectedFilters,page, size).subscribe(response => {
        if (response.data.tablePagination && response.data.tablePagination.last) {
          this.length = response.data.customerMappingRows.length;
        } else {
          this.length =
            this.paginator.pageSize * (this.paginator.pageIndex + 1) + 1;
        }
        //console.log(response)
        this.customerMappingData = response;
        this.isLoadingResults = false;
      },
      () => this.isLoadingResults = false);
    }

  }



  onSelectedFilter(selectedFilter: FormGroup) {
    if (
      (selectedFilter.value &&
        selectedFilter.value.tableFilter &&
        selectedFilter.value.value) ||
      (selectedFilter &&
        typeof selectedFilter.value.multipleFilterarray != "undefined" &&
        selectedFilter.value.multipleFilterarray != null &&
        selectedFilter.value.multipleFilterarray.length != null &&
        selectedFilter.value.multipleFilterarray.length > 0)
    ) {
      this.selectedFilters = selectedFilter;
      sessionStorage.setItem('setFilter', JSON.stringify(selectedFilter.value));
    } else {
      this.selectedFilters = null;
      this.initializeCustomerMapping(0,100);
    }
    this.paginator.pageSize = 100;
    this.paginator.firstPage();
    this.getFilters(0,100);
    // this.initializeCustomerMapping();
  }

  getInvoiceType(rentokilMapping: any[]): string {
    const isPDFAllowed = rentokilMapping.some(item => item.property === 'invoicePDFAllowed' && item.value === 'Yes');
    const isDataAllowed = rentokilMapping.some(item => item.property === 'invoiceDataAllowed' && item.value === 'Yes');

    if (isPDFAllowed && isDataAllowed) {
      return 'Invoice and PDF';
    } else if (isPDFAllowed) {
      return 'PDF';
    } else if (isDataAllowed) {
      return 'Invoice';
    } else {
      return ''; // Or any default value 
    }
  }

  hasInvoiceType(rentokilMapping: any[]): boolean {
    return this.getInvoiceType(rentokilMapping) !== null;
  }


    // Function to process rentokilMapping and ensure Invoice Type is at the end
    processRentokilMapping(rentokilMapping: any[]): MappingProperty[] {
      if (!rentokilMapping) return [];
      if (this.rentokilMappingCache.has(rentokilMapping)) {
        return this.rentokilMappingCache.get(rentokilMapping)!;
      }

      const otherProperties: MappingProperty[] = [];
      let invoiceTypeProperty: MappingProperty | null = null;
      let isInvoicingAllowedProperty: MappingProperty | null = null;
  
      rentokilMapping.forEach(item => {
        const mappingProperty: MappingProperty = {
          displayName: item.displayName,
          value: item.value,
          toolTip: item.toolTip,
          property: item.property
        };
        if (item.property === 'invoicePDFAllowed' || item.property === 'invoiceDataAllowed') {
          // Handle these together to form the Invoice Type
          if (!invoiceTypeProperty) {
            invoiceTypeProperty = { displayName: 'Invoice Type', value: this.getInvoiceType(rentokilMapping), toolTip: 'Indicates the type of invoice', property: 'invoiceType' };
          }
        } else if (item.property === 'isInvoicingAllowed') {
          isInvoicingAllowedProperty = { displayName: item.displayName, value: item.value === 'Yes' ? 'On' : 'Off', toolTip: item.toolTip, property: item.property };
        }
         else if (item.property !== 'invoicePDFAllowed' && item.property !== 'invoiceDataAllowed') {
          otherProperties.push(mappingProperty);
        }
      });
  
      const processedMapping = [...otherProperties];
      if (isInvoicingAllowedProperty) {
        processedMapping.push(isInvoicingAllowedProperty);
      }
      if (invoiceTypeProperty) {
        processedMapping.push(invoiceTypeProperty);
      }
      this.rentokilMappingCache.set(rentokilMapping, processedMapping);
      return processedMapping;
    }


  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
